
    import {
      getTerminologies
    } from "@/services/terminology";

    const state = {
      terminologies: [],
      processed: false
    };

    const getters = {
      terminologies(state) {
        return state.terminologies;
      },
      terminologyProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      initTerminologies({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getTerminologies(
              params
            )
              .then(response => {
                const terminologies = response.data.content;

                // Initialize an empty object
                let terminologyMap = {};

                // Iterate through the array of terminologies
                terminologies.forEach((term) => {
                    // Set each term name as a key in the map object, with its value
                    let key = term.name.toLowerCase();
                    terminologyMap[key] = term.value;
                });

                commit("SET_ACCOUNTTERMINOLOGIES", terminologyMap);
                resolve(terminologyMap);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_ACCOUNTTERMINOLOGIES(state, data) {
        state.terminologies = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      namespaced: true,
      state,
      getters,
      actions,
      mutations
    };
    